import React, { Component }  from "react";
import { Link } from "react-router-dom";
import formatLink from "../../utils/formatLink";
import axios from 'axios';
import Alert from "../../components/Alert/Alert";
import css from './FieldJobForms.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import moment from "moment";
import _ from 'lodash';
import {connect} from "react-redux";
import Downshift from 'downshift';

const BatteryForm = class extends Component{
    source = axios.CancelToken.source();
    pickfields = [];
    reqFields = ['Gateway_SN__c', 'Does_the_equipment_installed_match_the_p__c', 'Has_the_solar_been_tied_in__c', 'Battery_install_completed__c','Did_you_have_all_equipment_necessary__c',
        'Any_damage_to_siding_stucco__c', 'Customer_knows_the_status_of_the_job__c', 'Ready_for_final_inspection__c', 'Wall_conduit_painted__c'
    ];

    componentDidMount(){
        // Used to get picklist values for the below fields
        axios.get(
            '/sf/fieldjob/describeField/What_type_of_battery__c;CAD_Errors__c;Why_has_the_solar_not_been_tied_in__c;' +
            'Why_hasn_t_the_battery_been_installed__c;Why_not_supplied_with_all_equipment__c;Why_customer_doesn_t_know_status_of_job__c',
            {
                cancelToken: this.source.token
            })
            .then((resPickFields) => {
                this.pickfields = resPickFields.data;
            })
            .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
    }

    state = {
        isEditing: false,
        shouldShowAlert: false,
        Id: this.props.fieldJob.Id,
        What_type_of_battery__c: this.props.fieldJob.What_type_of_battery__c,
        Is_customer_registered_with_Tesla__c: this.props.fieldJob.Is_customer_registered_with_Tesla__c,
        Gateway_SN__c: this.props.fieldJob.Gateway_SN__c,
        X120_rule_did_we_setup_the_PCS_feature__c: this.props.fieldJob.X120_rule_did_we_setup_the_PCS_feature__c,
        X3_Foot_Fire_Clearance_Met__c: this.props.fieldJob.X3_Foot_Fire_Clearance_Met__c,
        Does_the_equipment_installed_match_the_p__c:this.props.fieldJob.Does_the_equipment_installed_match_the_p__c,
        CAD_Errors__c:this.props.fieldJob.CAD_Errors__c,
        Has_the_solar_been_tied_in__c:this.props.fieldJob.Has_the_solar_been_tied_in__c,
        Why_has_the_solar_not_been_tied_in__c:this.props.fieldJob.Why_has_the_solar_not_been_tied_in__c,
        Battery_install_completed__c:this.props.fieldJob.Battery_install_completed__c,
        Why_hasn_t_the_battery_been_installed__c:this.props.fieldJob.Why_hasn_t_the_battery_been_installed__c,
        Backup_Switch_Onsite__c:this.props.fieldJob.Backup_Switch_Onsite__c,
        Did_you_have_all_equipment_necessary__c:this.props.fieldJob.Did_you_have_all_equipment_necessary__c,
        Why_not_supplied_with_all_equipment__c:this.props.fieldJob.Why_not_supplied_with_all_equipment__c,
        Any_damage_to_siding_stucco__c:this.props.fieldJob.Any_damage_to_siding_stucco__c,
        Able_to_fix_on_site__c:this.props.fieldJob.Able_to_fix_on_site__c,
        Customer_knows_the_status_of_the_job__c:this.props.fieldJob.Customer_knows_the_status_of_the_job__c,
        Why_customer_doesn_t_know_status_of_job__c:this.props.fieldJob.Why_customer_doesn_t_know_status_of_job__c,
        Tested_battery_backup_for_10_minutes__c:this.props.fieldJob.Tested_battery_backup_for_10_minutes__c,
        Customer_confirmed_circuits__c:this.props.fieldJob.Customer_confirmed_circuits__c,
        Wall_conduit_painted__c:this.props.fieldJob.Wall_conduit_painted__c,
        Ready_for_final_inspection__c:this.props.fieldJob.Ready_for_final_inspection__c,
        Final_walkthrough_completed_cb__c:this.props.fieldJob.Final_walkthrough_completed_cb__c,
        Monitoring_set_up__c:this.props.fieldJob.Monitoring_set_up__c,
        Commissioning_Screen_Shots__c:this.props.fieldJob.Commissioning_Screen_Shots__c,
        Verify_CT_s_are_correct__c:this.props.fieldJob.Verify_CT_s_are_correct__c,
        All_battery_photos_uploaded__c:this.props.fieldJob.All_battery_photos_uploaded__c,
        Electrician_Notes__c: this.props.fieldJob.Electrician_Notes__c,

        Remaining_Electrical_Work__c: this.props.session.Opportunity__r.Electrical_Work__c !== null ? this.props.session.Opportunity__r.Electrical_Work__r.Remaining_Electrical_Work__c : null,

        fieldTeam: [],
        assignedCrew: {},
        addidtionalTech: ''
    };

    saveFields = () => {
        const payload = {...this.state};
        this.setState({shouldShowAlert: false, alertMessage: ''});

        delete payload.isEditing;
        delete payload.alertMessage;
        delete payload.shouldShowAlert;
        delete payload.Remaining_Electrical_Work__c;
        delete payload.fieldTeam;
        delete payload.assignedCrew;
        delete payload.addidtionalTech;

        if(this.state.fieldTeam.length !== 0){
            console.log(this.props.fieldTeam);
            let values = this.state.fieldTeam;
            let installCrew = '';
            values.forEach(value => {
                installCrew = installCrew + value + ',';
            });

            if(this.state.addidtionalTech !== ''){
                installCrew = installCrew + this.state.addidtionalTech;
            }

            payload.Install_Crew__c = installCrew;
        }

        console.log(payload);

        axios.put(
            '/sf/fieldjob/update',
            payload,
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                this.props.onSave(true);
                setTimeout(() => {
                    this.setState({isEditing: false});
                }, 1500);
            })
            .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
    };

    endJob = () => {
        const payload = {...this.state};

        if(this.validationCompleteCheck(payload)) {
            this.setState({shouldShowAlert: false, alertMessage: ''});
            delete payload.isEditing;
            delete payload.alertMessage;
            delete payload.shouldShowAlert;
            delete payload.Remaining_Electrical_Work__c;
            delete payload.fieldTeam;
            delete payload.assignedCrew;
            delete payload.addidtionalTech;

            payload.Clocked_End__c = moment().format(this.SF_DATE_TIME_FORMAT);
            payload.Status__c = 'Complete';
            payload.Completed_By__c = this.props.user.apiId;

            if(this.state.fieldTeam.length !== 0){
                let values = this.state.fieldTeam;
                let installCrew = '';
                values.forEach(value => {
                    installCrew = installCrew + value + ',';
                });
    
                if(this.state.addidtionalTech !== ''){
                    installCrew = installCrew + this.state.addidtionalTech;
                }
    
                payload.Install_Crew__c = installCrew;
            }

            axios.put(
                '/sf/fieldjob/update',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.props.onSave(true);
                    setTimeout(() => {
                        this.setState({isEditing: false});
                    }, 1500);
                })
                .catch(err => console.log('(PUT) Error while trying to update field job: \n', err));
        }
    };

    validationCompleteCheck = (payload) => {
        let valid = true;

        for (const key in payload) {
            if(this.reqFields.includes(key)){
                if(payload[key] === null) {
                    this.setState({shouldShowAlert: true, alertMessage: 'Please Fill Out Required Fields (*) Before Ending Job'})
                    valid = false;
                    break;
                }
            }

            if(this.state.Does_the_equipment_installed_match_the_p__c === 'No' && this.state.CAD_Errors__c === null){
                this.setState({shouldShowAlert: true, alertMessage: 'Please Select CAD Errors'});
                valid = false;
            }

            if(this.state.Has_the_solar_been_tied_in__c === 'No' && this.state.Why_has_the_solar_not_been_tied_in__c === null){
                this.setState({shouldShowAlert: true, alertMessage: 'Please Select Why Solar Has Not Been Tied In'});
                valid = false;
            }

            if(this.state.Battery_install_completed__c === 'No' && this.state.Why_hasn_t_the_battery_been_installed__c === null){
                this.setState({shouldShowAlert: true, alertMessage: 'Please Select Why Batter Install Has Not Been Completed'});
                valid = false;
            }

            if(this.state.Did_you_have_all_equipment_necessary__c === 'No' && this.state.Why_not_supplied_with_all_equipment__c === null){
                this.setState({shouldShowAlert: true, alertMessage: 'Please Select Why Not Supplied With All Equipment'});
                valid = false;
            }

            if(this.state.Any_damage_to_siding_stucco__c === 'Yes' && this.state.Able_to_fix_on_site__c === null){
                this.setState({shouldShowAlert: true, alertMessage: 'Please Select If Able To Fix Stucco On Site'});
                valid = false;
            }

            // Check if the Backup Switch is marked on the EW but is not selected on the battery form.
            if(this.props.session.Opportunity__r.Electrical_Work__c && this.props.session.Opportunity__r.Electrical_Work__r.Backup_Switch__c && this.state.Backup_Switch_Onsite__c === null){
                this.setState({shouldShowAlert: true, alertMessage: 'Please Select If Backup Switch Was Onside'});
                valid = false;
            }

            if(this.state.Customer_knows_the_status_of_the_job__c === 'No' && this.state.Why_customer_doesn_t_know_status_of_job__c === null){
                this.setState({shouldShowAlert: true, alertMessage: 'Please Select Why Customer Does Not Know Job Status'});
                valid = false;
            }
        }

        return valid;
    };

    // Handles the type of field needing to be entered and will list out their values
    // Also handles updating the state of the field being passed so additional logic 
    // can be ran and the form be built for saving the fields to salesforce.
    getInput = (inputType, field, fieldProps, fieldStateOptions) => {
        switch (inputType) {
            case 'yesNo':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.setState({[field]: event.target.value})}>
                            <option disabled value=""></option>
                            <option value="Yes">Yes</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                );
            case 'picklist':
                return(
                    <div className="pb-4">
                        <select id={field} value={fieldProps ? fieldProps : ''} onChange={(event) => this.setState({[field]: event.target.value})}>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'multiPicklist':
                return(
                    <div className="pb-4">
                        <select onChange={(event) => this.setState({[field]: this.assignMultiple(event.target.selectedOptions)})} multiple>
                            <option value="" hidden disabled></option>
                            { fieldStateOptions.map((option) => <option key={option.value} value={option.value}>{option.label}</option>) }
                        </select>
                    </div>
                );
            case 'num':
                return(
                    <div className="pb-4">
                        <input
                            type="number"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            case 'text':
                return(
                    <div className="pb-4">
                        <input
                            type="text"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            case 'checkbox':
                return(
                    <div className="pb-4">
                        <input
                            type="checkbox"
                            defaultChecked={fieldProps ? fieldProps : false}
                            onChange={(event) => this.setState({[field]: !event.target.defaultChecked})}
                        />
                    </div>
                );
            case 'textarea':
                return(
                    <div className="pb-4">
                        <textarea
                            rows="5"
                            value={fieldProps ? fieldProps : ''}
                            onChange={(event) => this.setState({[field]: event.target.value})}
                        />
                    </div>
                );
            default:
                return(
                    <div>
                        Not
                    </div>
                );
        };
    }

    assignMultiple = (value) => {
        const values = _.slice(value, [0], [value.length])
        const groupedValues = _.reduce(values, function(pickList, n) {
            return pickList + n.value + ';';
        }, '');

        return groupedValues;
    };

    updateFieldTeam = (selectedOptions) => {
        if(selectedOptions.length !== 0){
            let values = [];
            Array.from(selectedOptions).forEach(option => {
                values.push(option.value);
            });

            this.setState({fieldTeam: values});
        }
    };

    render(){
      return (
        <div className={css.FieldJobForms}>
            <Alert showAlert={this.state.shouldShowAlert}>{this.state.alertMessage} <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({shouldShowAlert: false, alertMessage: ''})} /></Alert>
            
            {/* Header of Field Job Form and includes buttons to End Job and Save */}
            <div className="d-flex justify-content-between mt-5 mb-4">
                <Link to={ this.props.session.Id ? `/scheduled/${this.props.session.Id}` : ''}>
                    <button className="btn btn-outline" type="button">Back</button>
                </Link>

                <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                    <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                    <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveFields()}>Save</button>
                </div>

                <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                    <a
                        href={formatLink(this.props.session.Jobsite_Photos__c ? this.props.session.Jobsite_Photos__c : '')}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <button className="btn btn-outline">Upload</button>
                    </a>
                    <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                </div>
            </div>

            <div className={this.props.fieldJob.Clocked_End__c ? 'd-none' : ''}>
                <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.endJob()}>End Job</button>
            </div>

            <div className={this.props.fieldJob.Clocked_End__c ? '' : 'd-none'}>
                <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.endJob()}>Job Completed</button>
            </div>
            {/* End of Header */}

            {
                this.state.isEditing ?

                // Render when editing
                <div className="text-white">
                    <h2 className="pt-4">Battery EOJ</h2>

                    <div className="py-2">
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Add Additional Tech On Site:</label>
                        <Downshift 
                            onChange={selection => this.setState({addidtionalTech: selection.id})}
                            itemToString={item => (item ? item.value : '')}
                        >
                            {({
                                getInputProps,
                                getItemProps,
                                getMenuProps,
                                isOpen,
                                inputValue,
                                highlightedIndex,
                                selectedItem
                            }) => (
                            <div>
                                <div className="w-72 flex flex-col gap-1">
                                    <div className="flex bg-white gap-0.5">
                                        <input className='form-control' placeholder="Type Tech's Name" {...getInputProps()} />
                                    </div>
                                </div>
                                <ul className="list-group" {...getMenuProps()}>
                                    {
                                        isOpen ? 
                                        this.props.activeFieldPersonnel.filter(item => !inputValue || (item.value).toLowerCase().includes(inputValue) || item.value.includes(inputValue))
                                            .map((item, index) => (
                                            <li className="list-group-item" {...getItemProps({key: item.value, index, item,
                                                style: {
                                                    backgroundColor:
                                                    highlightedIndex === index ? 'lightgray' : 'black',
                                                    fontWeight: selectedItem === item ? 'bold' : 'normal',
                                                },
                                                })}
                                            >
                                                {item.value}
                                            </li>
                                        ))
                                        : null
                                    }
                                </ul>
                            </div>
                            )}
                        </Downshift>
                    </div>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">What type of battery?</label>
                        {this.getInput('picklist', 'What_type_of_battery__c', this.state.What_type_of_battery__c, this.pickfields.What_type_of_battery__c.picklistValues)}
                    </div>

                    {/* Conditional Rendering for What_type_of_battery__c */}
                    <div className={this.state.What_type_of_battery__c === 'Tesla' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Is customer registered with Tesla?</label>
                            {this.getInput('yesNo', 'Is_customer_registered_with_Tesla__c', this.state.Is_customer_registered_with_Tesla__c)}
                        </div>
                    </div>
                    {/* End of What_type_of_battery__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Gateway SN *</label>
                        {this.getInput('text', 'Gateway_SN__c', this.state.Gateway_SN__c)}
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">If the sum of the amps for the  battery and solar exceeds the 120% rule did we setup the PCS feature?</label>
                        {this.getInput('yesNo', 'X120_rule_did_we_setup_the_PCS_feature__c', this.state.X120_rule_did_we_setup_the_PCS_feature__c)}
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">3 Foot Fire Clearance Met?</label>
                        {this.getInput('yesNo', 'X3_Foot_Fire_Clearance_Met__c', this.state.X3_Foot_Fire_Clearance_Met__c)}
                    </div>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Does equipment installed match plans? *</label>
                        {this.getInput('yesNo', 'Does_the_equipment_installed_match_the_p__c', this.state.Does_the_equipment_installed_match_the_p__c)}
                    </div>
                    {/* Conditional Rendering for Does_the_equipment_installed_match_the_p__c */}
                    <div className={this.state.Does_the_equipment_installed_match_the_p__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">CAD Errors: *</label>
                            {this.getInput('multiPicklist', 'CAD_Errors__c', this.state.CAD_Errors__c, this.pickfields.CAD_Errors__c.picklistValues)}
                        </div>
                    </div>
                    {/* End of Does_the_equipment_installed_match_the_p__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Has the solar been tied in? *</label>
                        {this.getInput('yesNo', 'Has_the_solar_been_tied_in__c', this.state.Has_the_solar_been_tied_in__c)}
                    </div>
                    {/* Conditional Rendering for Has_the_solar_been_tied_in__c */}
                    <div className={this.state.Has_the_solar_been_tied_in__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Why has the solar not been tied in? *</label>
                            {this.getInput('picklist', 'Why_has_the_solar_not_been_tied_in__c', this.state.Why_has_the_solar_not_been_tied_in__c, this.pickfields.Why_has_the_solar_not_been_tied_in__c.picklistValues)}
                        </div>
                    </div>
                    {/* End of Has_the_solar_been_tied_in__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Is the battery install complete? *</label>
                        {this.getInput('yesNo', 'Battery_install_completed__c', this.state.Battery_install_completed__c)}
                    </div>
                    {/* Conditional Rendering for Battery_install_completed__c */}
                    <div className={this.state.Battery_install_completed__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Why hasn't the battery been installed? *</label>
                            {this.getInput('multiPicklist', 'Why_hasn_t_the_battery_been_installed__c', this.state.Why_hasn_t_the_battery_been_installed__c, this.pickfields.Why_hasn_t_the_battery_been_installed__c.picklistValues)}
                        </div>
                    </div>
                    {/* End of Battery_install_completed__c */}

                    {/* Show only if the Backup Switch is marked on the EW */}
                    <div className={(this.props.session.Opportunity__r.Electrical_Work__c && this.props.session.Opportunity__r.Electrical_Work__r.Backup_Switch__c) ? 'mt-0' : 'd-none'}>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Backup Switch Onsite? *</label>
                        {this.getInput('yesNo', 'Backup_Switch_Onsite__c', this.state.Backup_Switch_Onsite__c)}
                    </div>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Were you supplied with all equipment necessary? *</label>
                        {this.getInput('yesNo', 'Did_you_have_all_equipment_necessary__c', this.state.Did_you_have_all_equipment_necessary__c)}
                    </div>
                    {/* Conditional Rendering for Did_you_have_all_equipment_necessary__c */}
                    <div className={this.state.Did_you_have_all_equipment_necessary__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Why were you not supplied with all equipment necessary? *</label>
                            {this.getInput('picklist', 'Why_not_supplied_with_all_equipment__c', this.state.Why_not_supplied_with_all_equipment__c, this.pickfields.Why_not_supplied_with_all_equipment__c.picklistValues)}
                        </div>
                    </div>
                    {/* End of Did_you_have_all_equipment_necessary__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Any damage to siding/stucco? *</label>
                        {this.getInput('yesNo', 'Any_damage_to_siding_stucco__c', this.state.Any_damage_to_siding_stucco__c)}
                    </div>
                    {/* Conditional Rendering for Any_damage_to_siding_stucco__c */}
                    <div className={this.state.Any_damage_to_siding_stucco__c === 'Yes' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Able to fix on site? *</label>
                            {this.getInput('yesNo', 'Able_to_fix_on_site__c', this.state.Able_to_fix_on_site__c)}
                        </div>
                    </div>
                    {/* End of Any_damage_to_siding_stucco__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Customer knows the status of the job? *</label>
                        {this.getInput('yesNo', 'Customer_knows_the_status_of_the_job__c', this.state.Customer_knows_the_status_of_the_job__c)}
                    </div>

                    {/* Conditional Rendering for Customer_knows_the_status_of_the_job__c */}
                    <div className={this.state.Customer_knows_the_status_of_the_job__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Why does the customer not know the status of the job? *</label>
                            {this.getInput('picklist', 'Why_customer_doesn_t_know_status_of_job__c', this.state.Why_customer_doesn_t_know_status_of_job__c, this.pickfields.Why_customer_doesn_t_know_status_of_job__c.picklistValues)}
                        </div>
                    </div>
                    {/* End of Customer_knows_the_status_of_the_job__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Tested battery backup for 10 minutes?</label>
                        {this.getInput('checkbox', 'Tested_battery_backup_for_10_minutes__c', this.state.Tested_battery_backup_for_10_minutes__c)}
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Customer confirmed circuits?</label>
                        {this.getInput('checkbox', 'Customer_confirmed_circuits__c', this.state.Customer_confirmed_circuits__c)}
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Wall conduit painted? *</label>
                        {this.getInput('yesNo', 'Wall_conduit_painted__c', this.state.Wall_conduit_painted__c)}
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Ready for final inspection? *</label>
                        {this.getInput('yesNo', 'Ready_for_final_inspection__c', this.state.Ready_for_final_inspection__c)}
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Final walkthrough completed?</label>
                        {this.getInput('checkbox', 'Final_walkthrough_completed_cb__c', this.state.Final_walkthrough_completed_cb__c)}
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Monitoring set up?</label>
                        {this.getInput('checkbox', 'Monitoring_set_up__c', this.state.Monitoring_set_up__c)}
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Commissioning Screen Shots?</label>
                        {this.getInput('checkbox', 'Commissioning_Screen_Shots__c', this.state.Commissioning_Screen_Shots__c)}
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Verify CTs are correct?</label>
                        {this.getInput('checkbox', 'Verify_CT_s_are_correct__c', this.state.Verify_CT_s_are_correct__c)}
                    </div> 
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">All battery photos uploaded?</label>
                        {this.getInput('checkbox', 'All_battery_photos_uploaded__c', this.state.All_battery_photos_uploaded__c)}
                    </div> 
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Electrician Notes:</label>
                        {this.getInput('textarea', 'Electrician_Notes__c', this.state.Electrician_Notes__c)}
                    </div>
                </div>

                :

                // RENDER WHEN NOT EDITING
                // 

                <div className="text-white">
                    <h2 className="pt-4">Battery EOJ</h2>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">What type of battery?</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.What_type_of_battery__c ? this.props.fieldJob.What_type_of_battery__c : '---'}</div>
                    </div>
                    {/* Conditional Rendering for What_type_of_battery__c */}
                    <div className={this.props.fieldJob.What_type_of_battery__c === 'Tesla' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Is customer registered with Tesla?</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Is_customer_registered_with_Tesla__c ? this.props.fieldJob.Is_customer_registered_with_Tesla__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of What_type_of_battery__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Gateway SN *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Gateway_SN__c ? this.props.fieldJob.Gateway_SN__c : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">If the sum of the amps for the  battery and solar exceeds the 120% rule did we setup the PCS feature?</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.X120_rule_did_we_setup_the_PCS_feature__c ? this.props.fieldJob.X120_rule_did_we_setup_the_PCS_feature__c : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">3 Foot Fire Clearance Met?</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.X3_Foot_Fire_Clearance_Met__c ? this.props.fieldJob.X3_Foot_Fire_Clearance_Met__c : '---'}</div>
                    </div>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Does equipment installed match plans? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Does_the_equipment_installed_match_the_p__c ? this.props.fieldJob.Does_the_equipment_installed_match_the_p__c : '---'}</div>
                    </div>
                    {/* Conditional Rendering for Does_the_equipment_installed_match_the_p__c */}
                    <div className={this.props.fieldJob.Does_the_equipment_installed_match_the_p__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">CAD Errors: *</label>
                            <div className="col-sm-7 col-12">{this.props.fieldJob.CAD_Errors__c ? this.props.fieldJob.CAD_Errors__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Does_the_equipment_installed_match_the_p__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Has the solar been tied in? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Has_the_solar_been_tied_in__c ? this.props.fieldJob.Has_the_solar_been_tied_in__c : '---'}</div>
                    </div>
                    {/* Conditional Rendering for Has_the_solar_been_tied_in__c */}
                    <div className={this.props.fieldJob.Has_the_solar_been_tied_in__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Why has the solar not been tied in? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Why_has_the_solar_not_been_tied_in__c ? this.props.fieldJob.Why_has_the_solar_not_been_tied_in__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Has_the_solar_been_tied_in__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Is the battery install complete? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Battery_install_completed__c ? this.props.fieldJob.Battery_install_completed__c : '---'}</div>
                    </div>
                    {/* Conditional Rendering for Battery_install_completed__c */}
                    <div className={this.props.fieldJob.Battery_install_completed__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Why hasn't the battery been installed? *</label>
                            <div className="col-sm-7 col-12">{this.props.fieldJob.Why_hasn_t_the_battery_been_installed__c ? this.props.fieldJob.Why_hasn_t_the_battery_been_installed__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Battery_install_completed__c */}

                    {/* Show only if the Backup Switch is marked on the EW */}
                    <div className={(this.props.session.Opportunity__r.Electrical_Work__c && this.props.session.Opportunity__r.Electrical_Work__r.Backup_Switch__c) ? 'mt-0' : 'd-none'}>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Backup Switch Onsite? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Backup_Switch_Onsite__c ? this.props.fieldJob.Backup_Switch_Onsite__c : '---'}</div>
                    </div>

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Were you supplied with all equipment necessary? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Did_you_have_all_equipment_necessary__c ? this.props.fieldJob.Did_you_have_all_equipment_necessary__c : '---'}</div>
                    </div>
                    {/* Conditional Rendering for Did_you_have_all_equipment_necessary__c */}
                    <div className={this.props.fieldJob.Did_you_have_all_equipment_necessary__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Why were you not supplied with all equipment necessary? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Why_not_supplied_with_all_equipment__c ? this.props.fieldJob.Why_not_supplied_with_all_equipment__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Did_you_have_all_equipment_necessary__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Any damage to siding/stucco? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Any_damage_to_siding_stucco__c ? this.props.fieldJob.Any_damage_to_siding_stucco__c : '---'}</div>
                    </div>
                    {/* Conditional Rendering for Any_damage_to_siding_stucco__c */}
                    <div className={this.props.fieldJob.Any_damage_to_siding_stucco__c === 'Yes' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Able to fix on site? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Able_to_fix_on_site__c ? this.props.fieldJob.Able_to_fix_on_site__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Any_damage_to_siding_stucco__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Customer knows the status of the job? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Customer_knows_the_status_of_the_job__c ? this.props.fieldJob.Customer_knows_the_status_of_the_job__c : '---'}</div>
                    </div>
                    {/* Conditional Rendering for Customer_knows_the_status_of_the_job__c */}
                    <div className={this.props.fieldJob.Customer_knows_the_status_of_the_job__c === 'No' ? 'mt-0' : 'd-none'}>
                        <div>
                            <label className="text-white col-sm-5 col-12 m-0 py-2">Why does the customer not know the status of the job? *</label>
                            <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Why_customer_doesn_t_know_status_of_job__c ? this.props.fieldJob.Why_customer_doesn_t_know_status_of_job__c : '---'}</div>
                        </div>
                    </div>
                    {/* End of Customer_knows_the_status_of_the_job__c */}

                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Tested battery backup for 10 minutes?</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Tested_battery_backup_for_10_minutes__c ? 'Yes' : !this.props.fieldJob.Tested_battery_backup_for_10_minutes__c ? 'No' : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Customer confirmed circuits?</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Customer_confirmed_circuits__c ? 'Yes' : !this.props.fieldJob.Customer_confirmed_circuits__c ? 'No' : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Wall conduit painted? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Wall_conduit_painted__c ? this.props.fieldJob.Wall_conduit_painted__c : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Ready for final inspection? *</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Ready_for_final_inspection__c ? this.props.fieldJob.Ready_for_final_inspection__c : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Final walkthrough completed?</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Final_walkthrough_completed_cb__c ? 'Yes' : !this.props.fieldJob.Final_walkthrough_completed_cb__c ? 'No' : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Monitoring set up?</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Monitoring_set_up__c ? 'Yes' : !this.props.fieldJob.Monitoring_set_up__c ? 'No' : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Commissioning Screen Shots?</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Commissioning_Screen_Shots__c ? 'Yes' : !this.props.fieldJob.Commissioning_Screen_Shots__c ? 'No' : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Verify CTs are correct?</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.Verify_CT_s_are_correct__c ? 'Yes' : !this.props.fieldJob.Verify_CT_s_are_correct__c ? 'No' : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">All battery photos uploaded?</label>
                        <div className="d-inline col-sm-7 col-12">{this.props.fieldJob.All_battery_photos_uploaded__c ? 'Yes' : !this.props.fieldJob.All_battery_photos_uploaded__c ? 'No' : '---'}</div>
                    </div>
                    <div>
                        <label className="text-white col-sm-5 col-12 m-0 py-2">Electrician Notes:</label>
                        <div className="col-sm-7 col-12">{this.props.fieldJob.Electrician_Notes__c ? this.props.fieldJob.Electrician_Notes__c : '---'}</div>
                    </div>
                </div>
            }

            {/* Footer of Field Job Form that includs the buttons for Endind and Saving Job */}
            <div className="mt-5 mb-4">
                <div className={this.props.fieldJob.Clocked_End__c ? 'd-none' : ''}>
                    <button className="btn btn-outline w-100 text-md" type="button" onClick={() => this.endJob()}>End Job</button>
                </div>

                <div className={this.props.fieldJob.Clocked_End__c ? '' : 'd-none'}>
                    <button className="btn btn-outline w-100 text-md" type="button" disabled="true" onClick={() => this.endJob()}>Job Completed</button>
                </div>
                <div className="d-flex justify-content-between mt-3">
                    {/* the ternary expression prevents user from clicking the link before `schedulableId` has been fetched: */}
                    <Link to={ this.props.session.Id ? `/scheduled/${this.props.session.Id}` : ''}>
                        <button className="btn btn-outline" type="button">Back</button>
                    </Link>

                    <div className={this.state.isEditing ? 'text-right' : 'd-none'}>
                        <button className="btn btn-outline" type="button" onClick={ () => this.setState({ isEditing: false }) }>Cancel</button>
                        <button className="btn btn-outline ml-2" type="button" onClick={() => this.saveFields()}>Save</button>
                    </div>

                    <div className={this.state.isEditing ? 'd-none' : 'text-right'}>
                        <a
                            href={formatLink(this.props.session.Jobsite_Photos__c ? this.props.session.Jobsite_Photos__c : '')}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <button className="btn btn-outline">Upload</button>
                        </a>
                        <button className="btn btn-outline ml-2" type="button" onClick={ () => this.setState({ isEditing: true }) }>Edit</button>
                    </div>

                </div>
            </div>

        </div>
    )};
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(BatteryForm);